import React from 'react';

// Styles & Assets
import styles from './InputNumArrows.module.css';
import { MdOutlineKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';

// Interfaces
import { ActionTime, TUnit } from '../../../interfaces/Reducers';

interface Props {
    value: string | null | undefined
    unit: TUnit
    dispatchTime: React.Dispatch<ActionTime>
}

const InputNumArrows: React.FC<Props> = ({ value, unit, dispatchTime }) => {

    const handleClick = (increment: boolean) => {
        dispatchTime({ type: increment ? 'increment' : 'decrement', unit });
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatchTime({ type: 'set', unit, payload: e.target.value });
    };

    return (
        <> {value !== undefined ?
            <div className={styles.timeSelect}>
                <MdOutlineKeyboardArrowUp className={styles.arrowIcon} onClick={() => handleClick(true)} />
                <input
                    type='number'
                    className={styles.inputTime}
                    value={value ?? ''}
                    onChange={onChange}
                />
                <MdOutlineKeyboardArrowDown className={styles.arrowIcon} onClick={() => handleClick(false)} />
            </div>
            : null
        } </>
    );
};

export default InputNumArrows;